import { defineNuxtPlugin } from '#app'
import { defineAsyncComponent } from 'vue'
import UserAvator from '@/components/common/UserAvator.vue'
import ArticleDetailItem from '@/components/render/ArticleDetailItem.vue'
import ArticleListItem from '@/components/render/ArticleListItem.vue'
import Banner from '@/components/render/Banner.vue'
import CheckboxItem from '@/components/render/CheckboxItem.vue'
import Col from '@/components/render/Col.vue'
import CommonComponentsItem from '@/components/render/CommonComponentsItem.vue'
import ElementItem from '@/components/render/ElementIndex.vue'
import HtmlItem from '@/components/render/HtmlItem.vue'
import ImageItem from '@/components/render/ImageItem.vue'
import InputItem from '@/components/render/InputItem.vue'
import NavigationBar from '@/components/render/NavigationBar/index.vue'
import MobileNavigationBar from '@/components/render/NavigationBar/mobile.vue'
import OriginalComponentsItem from '@/components/render/OriginalComponentsItem.vue'
import ProductDetail1688Item from '@/components/render/ProductDetail1688Item.vue'
import Row from '@/components/render/Row.vue'
import SelectItem from '@/components/render/SelectItem.vue'
import TabsItem from '@/components/render/TabsItem.vue'
import TextItem from '@/components/render/TextItem.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('ProductDetail1688Item', ProductDetail1688Item)
  nuxtApp.vueApp.component('CommonComponentsItem', CommonComponentsItem)
  nuxtApp.vueApp.component('ElementItem', ElementItem)
  nuxtApp.vueApp.component('CheckboxItem', CheckboxItem)
  nuxtApp.vueApp.component('InputItem', InputItem)
  nuxtApp.vueApp.component('SelectItem', SelectItem)

  nuxtApp.vueApp.component('Row', Row)
  nuxtApp.vueApp.component('Col', Col)
  nuxtApp.vueApp.component('ImageItem', ImageItem)
  nuxtApp.vueApp.component('TextItem', TextItem)
  nuxtApp.vueApp.component('Banner', Banner)
  nuxtApp.vueApp.component('NavigationBar', NavigationBar)
  nuxtApp.vueApp.component('ArticleListItem', ArticleListItem)
  nuxtApp.vueApp.component('TabsItem', TabsItem)
  nuxtApp.vueApp.component('OriginalComponentsItem', OriginalComponentsItem)

  nuxtApp.vueApp.component('HtmlItem', HtmlItem)
  nuxtApp.vueApp.component('ArticleDetailItem', ArticleDetailItem)
  nuxtApp.vueApp.component('MobileNavigationBar', MobileNavigationBar)
  nuxtApp.vueApp.component('UserAvator', UserAvator)

  nuxtApp.vueApp.component('TransportRoutes', defineAsyncComponent(() => import(/* webpackChunkName: "TransportRoutes" */ '@/components/render/common/TransportRoutes.vue')))
  nuxtApp.vueApp.component('OrderSearchBar', defineAsyncComponent(() => import(/* webpackChunkName: "OrderSearchBar" */ '@/components/render/common/OrderSearchBar.vue')))
  nuxtApp.vueApp.component('OrderSearchMobileBar', defineAsyncComponent(() => import(/* webpackChunkName: "OrderSearchMobileBar" */ '@/components/render/common/OrderSearchMobileBar.vue')))
  nuxtApp.vueApp.component('TopicArticleListItem', defineAsyncComponent(() => import(/* webpackChunkName: "TopicArticleListItem" */ '@/components/render/TopicArticleListItem/index.vue')))

  nuxtApp.vueApp.component('MallNavigationBar', defineAsyncComponent(() => import(/* webpackChunkName: "MallNavigationBar" */ '@/components/render/mall/Nav/index.vue')))
  nuxtApp.vueApp.component('MallGoodsCard', defineAsyncComponent(() => import(/* webpackChunkName: "MallGoodsCard" */ '@/components/render/mall/goods/card/GoodsCard.vue')))
  nuxtApp.vueApp.component('ShopGoodsList', defineAsyncComponent(() => import(/* webpackChunkName: "ShopGoodsList" */ '@/components/render/shop/goods/list/GoodsList.vue')))
  nuxtApp.vueApp.component('MistrivoEmailSignup', defineAsyncComponent(() => import('@/components/render/australia/MistrivoEmailSignup.vue')))
  nuxtApp.vueApp.component('MistrivoProductSection', defineAsyncComponent(() => import('@/components/render/australia/MistrivoProductSection.vue')))
  nuxtApp.vueApp.component('MistrivoWelcomeOffer', defineAsyncComponent(() => import('@/components/render/australia/MistrivoWelcomeOffer.vue')))
  nuxtApp.vueApp.component('MarqueeComments', defineAsyncComponent(() => import(/* webpackChunkName: "MarqueeComments" */ '@/components/render/common/MarqueeComments.vue')))
  nuxtApp.vueApp.component('CommemtShop', defineAsyncComponent(() => import(/* webpackChunkName: "CommemtShop" */ '@/components/render/common/CommemtShop.vue')))
  nuxtApp.vueApp.component('WaterfallCommentShop', defineAsyncComponent(() => import(/* webpackChunkName: "WaterfallCommentShop" */ '@/components/render/common/WaterfallCommentShop.vue')))
  nuxtApp.vueApp.component('JapanCommentShop', defineAsyncComponent(() => import(/* webpackChunkName: "JapanCommentShop" */ '@/components/render/common/JapanCommentShop.vue')))
})
